import { useEffect, useRef } from 'react'

import { clsx } from 'clsx'

import { useBlock, useSlate } from '@tribeplatform/react-slate-kit/hooks'
import {
  BlockWrapperComponent,
  LayoutBlockProps,
  LBC,
  UnknownProps,
} from '@tribeplatform/react-slate-kit/types'
import { useDocument } from '@tribeplatform/react-ui-kit/hooks'

import { EditorBlockExtraContext, EditorSlateExtraContext } from '../types.js'
import { customizerPreviewScrollTo } from './utils.js'

export const LayoutWrapper: BlockWrapperComponent = ({
  Block,
  childrenBlocks,
}) => {
  const { document } = useDocument()
  const { mode } = useSlate<EditorSlateExtraContext, EditorBlockExtraContext>()

  const {
    block: { compiledProps },
    extraContext: { focused, selected, activated },
  } = useBlock<UnknownProps, EditorBlockExtraContext>()

  const LayoutBlock = Block as LBC<LayoutBlockProps>
  const layoutProps = compiledProps as LayoutBlockProps

  const ref = useRef<HTMLDivElement>()
  useEffect(() => {
    if (ref.current && selected && mode === 'edit') {
      customizerPreviewScrollTo(ref.current, document)
    }
  }, [selected, ref, mode, document])

  return (
    <LayoutBlock
      {...layoutProps}
      containerProps={{
        ref,
        className: clsx(
          layoutProps?.containerProps?.className,
          (selected || focused) && [
            'rounded-base ring-offset-4 ring-2',
            focused && 'ring-customizer-blue border-customizer-blue',
            selected && 'ring-customizer-blue border-customizer-blue',
          ],
          activated && 'relative z-40 bg-background',
        ),
      }}
    >
      {childrenBlocks}
    </LayoutBlock>
  )
}
